import { Box, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import Alert from '@Components/Alert';
import Button from '@Components/Button';
import Tab from '@Components/Tab';
import commonConstants from '@Constants/common.constants';

import MainSectionLayoutProps from './MainSectionLayout.types';

const MainSectionLayout: FunctionComponent<MainSectionLayoutProps> = (
  props: MainSectionLayoutProps
): JSX.Element => {
  const {
    heading,
    backBtnProps,
    tabProps,
    tabChild,
    filters,
    table,
    alertState,
  } = props;

  /**
   * Reset Alert
   */
  const resetAlert = () => {
    if (alertState?.resetAlert) {
      alertState.resetAlert((prevState) => ({
        ...prevState,
        openAlert: false,
      }));
    }
  };

  return (
    <Box
      sx={{
        px: 2.4,
        pb: 2.4,
        pt: backBtnProps ? 1.6 : 2.4,
        p: tabChild ? 0 : undefined,
      }}
    >
      {alertState && (
        <Alert
          open={alertState.openAlert}
          autoHideDuration={commonConstants.ALERT_HIDING_TIME}
          text={alertState.message}
          severity={alertState.severity}
          closeBtnProps={{
            onClick: resetAlert,
          }}
          onClose={resetAlert}
          className="base-alert"
          sx={{
            '&.base-alert': {
              top: '0',
              left: '50%',
              height: '5.6rem',
              transform: 'translateX(-50%)',
            },
          }}
        />
      )}
      {backBtnProps && (
        <Button
          variant="text"
          color="secondary"
          sx={{ textTransform: 'none', marginBottom: '1.6rem' }}
          icon="keyboardArrowLeft"
          {...backBtnProps}
        />
      )}
      {typeof heading === 'string' ? (
        <Typography mb={2.4} variant="h1">
          {heading}
        </Typography>
      ) : (
        heading
      )}
      {tabProps ? (
        <Tab {...tabProps} />
      ) : (
        <>
          {filters && <Box mb={2.4}>{filters}</Box>}
          {table}
        </>
      )}
    </Box>
  );
};

export default MainSectionLayout;
